'use client';

import { useState } from 'react';
import { BreadcrumbChevron, BREADCRUMB_SEGMENT_LI_CLASSES } from './breadcrumb-chevron';

/** `href` is absent for a crumb with no page: it renders as text, not a link. */
export type CrumbItem = { name: string; href?: string };

export function BreadcrumbCollapse({ items }: { items: CrumbItem[] }) {
  const [expanded, setExpanded] = useState(false);

  if (items.length === 0) return null;

  return (
    <>
      {items.map((item, i) => (
        <li
          key={i}
          className={`${BREADCRUMB_SEGMENT_LI_CLASSES} shrink-[2] ${expanded ? '' : 'hidden sm:flex'}`}
        >
          {item.href ? (
            <a href={item.href} className="min-w-0 flex-1 truncate">
              {item.name}
            </a>
          ) : (
            <span className="min-w-0 flex-1 truncate">{item.name}</span>
          )}
          <BreadcrumbChevron />
        </li>
      ))}

      {!expanded && (
        <li className={`${BREADCRUMB_SEGMENT_LI_CLASSES} shrink-0 sm:hidden`}>
          <button
            type="button"
            onClick={() => setExpanded(true)}
            aria-label="Expand breadcrumb path"
            aria-expanded={false}
            className="m-0 flex h-5 min-w-[1rem] shrink-0 cursor-pointer items-center justify-center border-0 bg-transparent p-0 font-inherit text-muted-foreground hover:text-foreground"
          >
            …
          </button>
          <BreadcrumbChevron />
        </li>
      )}
    </>
  );
}
